<template>
  <div v-if="user && user.has_user_changed_password" id="platform" class="PlatformView view">
    <TheHeader :holiday-list="holidayList" :user="user" :agents-list="agentsBelongsToUserList" />
    <TheMainMenu slot="content" :user="user" />
    <div class="PlatformView__pages">
      <MainBackground />
      <div class="PlatformView__content">
        <transition name="fade">
          <router-view />
        </transition>
        <CopyrightSection />
      </div>
      <TheRecordPlayer v-if="isPlayerVisible" />
    </div>
    <el-backtop target=".PlatformView__content" />
  </div>
  <div v-else-if="user && !user.has_user_changed_password" class="PlatformView view">
    <ChangePassword :user-details="user" />
  </div>
</template>

<script>
import store from "@/store";
import { hDeepCopy } from "@/utils/helpers";
import ChangePassword from "@/components/Users/ChangePassword";
import TheHeader from "@/components/Platform/TheHeader";
import TheMainMenu from "@/components/Platform/TheMainMenu";
import MainBackground from "@/components/Common/MainBackground";
import CopyrightSection from "@/components/Common/CopyrightSection";
import TheRecordPlayer from "@/components/Platform/TheRecordPlayer";
import { version } from "../../package.json";

export default {
  name: "Platform",
  store,
  components: {
    TheHeader,
    TheMainMenu,
    CopyrightSection,
    MainBackground,
    TheRecordPlayer,
    ChangePassword
  },
  data() {
    return {
      isPlayerVisible: false,
      user: null
    };
  },
  computed: {
    activePathName() {
      return this.$route.path;
    },
    agentsBelongsToUserList() {
      return hDeepCopy(this.$store.getters["user/agent/agentsBelongsToUserlist"].records);
    },
    holidayList() {
      // if the holiday is per agent, then it applies only to that agent, if per project, then to all agents of that project
      /* eslint-disable no-nested-ternary */
      let currentHolidays = hDeepCopy(
        this.$store.getters["client/project/holidays/currentList"].records
      ).map(holiday =>
        holiday.element === "agent" &&
        this.agentsBelongsToUserList.some(agent => agent.id === holiday.element_id)
          ? { ...holiday, isCurrent: true }
          : holiday.element === "project"
          ? { ...holiday, isCurrent: true }
          : { ...holiday, isCurrent: false }
      );

      return currentHolidays.filter(holiday => holiday.isCurrent);
    }
  },
  mounted() {
    this.$EventBus.$on("RecordListItem/TURN_PLAYER_VISIBILITY_ON", () =>
      this.turnPlayerVisilibityOn()
    );
    this.$EventBus.$on("PlatformConnections/TURN_PLAYER_VISIBILITY_OFF", () =>
      this.turnPlayerVisilibityOff()
    );
  },
  beforeDestroy() {
    this.$EventBus.$off("RecordListItem/TURN_PLAYER_VISIBILITY_ON");
    this.$EventBus.$off("PlatformConnections/TURN_PLAYER_VISIBILITY_OFF");
  },
  async created() {
    console.log("VERSION:", version);
    await this.$store.dispatch("client/project/holidays/getCurrentList");
    await this.$store.dispatch("campaigns/getList");
    this.user = await this.$store.getters["authorization/user"];
    await this.$store.dispatch("client/projects/getList", this.user.client.client_uuid);
  },
  methods: {
    turnPlayerVisilibityOn() {
      this.isPlayerVisible = true;
    },
    turnPlayerVisilibityOff() {
      this.isPlayerVisible = false;
    }
  }
};
</script>

<style lang="sass">
.PlatformView
  display: flex
  flex: 1 1 auto
  flex-direction: column
  min-height: 0

  &__pages
    display: flex
    flex: 1 1 auto
    flex-direction: column
    min-height: 0

  &__content
    display: flex
    flex: 1 1 auto
    flex: 1 1 auto
    flex-direction: column
    height: 0
    min-height: 0
    overflow-y: auto
    position: relative
</style>
